import React from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from "reactstrap";

const ConfirmOboDeleteModal = ({ isOpen, onConfirm, onExit, pairingInfo }) => {
    return (
        <Modal isOpen={isOpen} toggle={onExit} className="confirm-obo-modal">
            <ModalHeader toggle={onExit}>
                Odpárovat klienta
            </ModalHeader>
            <ModalBody className="text-center">
                Opravdu chcete odpárovat klienta:
                <br/>
                <strong>{pairingInfo?.fullName} ({pairingInfo?.cluid})</strong>
            </ModalBody>
            <ModalFooter className="justify-content-center">
                <Button color="danger" onClick={onConfirm}>Odpárovat</Button>
                <Button color="secondary" onClick={onExit}>Zrušit</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ConfirmOboDeleteModal;
